var map = {
	"./apple-dark.svg": [
		5323,
		323
	],
	"./apple-icon.png": [
		8848,
		848
	],
	"./apple-light.png": [
		7207,
		207
	],
	"./google-dark.svg": [
		6485,
		485
	],
	"./google-icon.png": [
		5566,
		566
	],
	"./google-light.png": [
		1530,
		530
	],
	"./icon-xl.png": [
		3165
	],
	"./icon.png": [
		6003,
		3
	],
	"./mail.svg": [
		6223
	],
	"./patreon-dark.png": [
		4764,
		764
	],
	"./patreon-icon.png": [
		7752,
		752
	],
	"./patreon-light.png": [
		540,
		540
	],
	"./raw-logo-fancy.png": [
		672,
		672
	],
	"./raw-logo-fancy.webp": [
		3060
	],
	"./spotify-dark.png": [
		861,
		861
	],
	"./spotify-icon.png": [
		3930,
		930
	],
	"./spotify-light.png": [
		6655,
		655
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 1974;
module.exports = webpackAsyncContext;